import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

/**
 * Página legal genérica (Términos y condiciones, Política de privacidad, Política
 * de cookies). El contenido vive en i18n bajo `legal.<key>.*` y se selecciona con
 * el `key` declarado en la ruta (data.key).
 */
@Component({
  selector: 'app-legal-page',
  templateUrl: './legal-page.component.html',
  styleUrls: ['./legal-page.component.scss'],
})
export class LegalPageComponent implements OnInit, OnDestroy {
  titleKey = '';
  updatedKey = '';
  bodyKey = '';
  private sub?: Subscription;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.sub = this.route.data.subscribe((data) => {
      const key = data['key'];
      this.titleKey = `legal.${key}.title`;
      this.updatedKey = `legal.${key}.updated`;
      this.bodyKey = `legal.${key}.bodyHtml`;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
